// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a[type=button][data-v-453710b4]{-webkit-appearance:none}a[data-v-453710b4]{display:inline-block}button[data-v-453710b4]:disabled{opacity:.25;cursor:not-allowed}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
